<!-- Toast Messages - Positioned at root level -->
<p-toast
  data-testid="purchase-order-config-toast"
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [showTransformOptions]="'translateX(100%)'"
  [hideTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'0.3s ease-in'"
  [hideTransitionOptions]="'0.3s ease-out'"
  [preventDuplicates]="false"
></p-toast>

<div class="p-6" data-testid="purchase-order-config-page">
  <!-- Header -->
  <h2
    class="text-2xl font-semibold text-gray-800 mb-6"
    style="font-size: 1.5rem; font-weight: 600"
  >
    {{ "purchase_order_config.title" | translate }}
  </h2>

  <div class="settings-container">
    <!-- Left Sidebar Navigation -->
    <div class="settings-sidebar">
      <div class="sidebar-header">
        <div class="sidebar-title">
          {{ "purchase_order_config.sections.field_management" | translate }}
        </div>
      </div>

      <div class="sidebar-content">
        <div class="sidebar-section">
          @for (field of poFields(); track field.fieldKey) {
            <div class="sidebar-item-container">
              <button
                [attr.data-testid]="
                  'purchase-order-config-field-button-' + field.fieldKey
                "
                class="sidebar-item"
                [class.active]="selectedField() === field.fieldKey"
                (click)="selectField(field)"
                type="button"
                [attr.aria-label]="getFieldDisplayName(field.fieldKey)"
              >
                <i class="pi pi-file-edit sidebar-icon"></i>
                <span class="sidebar-label">
                  {{ getFieldDisplayName(field.fieldKey) }}
                </span>
              </button>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="settings-main">
      <div class="settings-content">
        <!-- Form Content -->
        <div class="form-content">
          <div class="settings-section">
            <div class="section-header-with-actions">
              <h5 class="section-header">
                @if (currentFieldConfig()) {
                  {{ getFieldDisplayName(currentFieldConfig()!.fieldKey) }}
                } @else {
                  {{
                    "purchase_order_config.sections.field_configuration"
                      | translate
                  }}
                }
              </h5>
              @if (canUpdate()) {
                <div class="status-toggle-container">
                  <p-toggleSwitch
                    [attr.data-testid]="
                      'purchase-order-config-active-toggle-' +
                      (currentFieldConfig()?.fieldKey || 'none')
                    "
                    [ngModel]="currentFieldConfig()?.isActive ?? false"
                    (ngModelChange)="toggleConfigActive($event)"
                    [ngModelOptions]="{ standalone: true }"
                    [inputId]="'config-active-toggle'"
                    class="config-active-toggle"
                    [style]="getToggleSwitchStyle()"
                    [disabled]="!currentFieldConfig()"
                  ></p-toggleSwitch>
                </div>
              }
            </div>
            <p class="section-description">
              @if (currentFieldConfig()?.description) {
                {{ currentFieldConfig()!.description! | translate }}
              } @else {
                {{
                  "purchase_order_config.descriptions.field_configuration"
                    | translate
                }}
              }
            </p>

            <div class="settings-group">
              <!-- Field Name (Read-only) -->
              <div class="setting-item">
                <div class="setting-label">
                  <label for="field-name">
                    {{
                      "purchase_order_config.form.fields.field_name" | translate
                    }}
                  </label>
                  <span class="setting-description">
                    {{
                      "purchase_order_config.descriptions.field_name"
                        | translate
                    }}
                  </span>
                </div>
                <div class="setting-control">
                  <div
                    class="config-display-value"
                    data-testid="purchase-order-config-field-name-value"
                  >
                    @if (currentFieldConfig()) {
                      {{ getFieldDisplayName(currentFieldConfig()!.fieldKey) }}
                    } @else {
                      {{
                        "purchase_order_config.form.placeholders.select_field"
                          | translate
                      }}
                    }
                  </div>
                </div>
              </div>

              <!-- Field Requirement Status -->
              <div class="setting-item">
                <div class="setting-label">
                  <label for="field-required">
                    {{
                      "purchase_order_config.form.fields.field_required"
                        | translate
                    }}
                  </label>
                  <span class="setting-description">
                    {{
                      "purchase_order_config.descriptions.field_required"
                        | translate
                    }}
                  </span>
                </div>
                <div class="setting-control">
                  <div class="checkbox-container">
                    <p-toggleSwitch
                      [attr.data-testid]="
                        'purchase-order-config-required-toggle-' +
                        (currentFieldConfig()?.fieldKey || 'none')
                      "
                      id="field-required"
                      name="field-required"
                      [ngModel]="currentFieldConfig()?.isRequired ?? false"
                      (ngModelChange)="toggleFieldRequirement($event)"
                      [ngModelOptions]="{ standalone: true }"
                      [disabled]="
                        !currentFieldConfig() ||
                        !currentFieldConfig()?.isActive ||
                        !canUpdate()
                      "
                      [inputId]="'field-required-toggle'"
                      class="field-required-toggle"
                      [style]="getToggleSwitchStyle()"
                    ></p-toggleSwitch>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        @if (canUpdate()) {
          <div class="action-buttons-section">
            <div class="form-action-buttons">
              <app-button
                [testId]="'purchase-order-config-reset-btn'"
                [label]="'common.actions.reset' | translate"
                type="secondary"
                [outlined]="true"
                (emitOnClick)="onReset()"
                class="reset-button"
              ></app-button>
              <app-button
                [testId]="'purchase-order-config-save-btn'"
                [label]="'common.actions.save' | translate"
                type="info"
                (emitOnClick)="onSave()"
                class="save-button"
              ></app-button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
